import { render, staticRenderFns } from "./wheel.vue?vue&type=template&id=235d79fe"
import script from "./wheel.vue?vue&type=script&lang=js"
export * from "./wheel.vue?vue&type=script&lang=js"
import style0 from "./wheel.vue?vue&type=style&index=0&id=235d79fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports